import '@n8n/chat/dist/style.css'
import './chat-ai.styles.css'

import { useContext, useEffect } from 'react'

import { createChat } from '@n8n/chat'

const FASHION_COMPANY_CHAT_URL =
  'https://webhookff.fairfashion.io/webhook/fe7d79f9-f9c7-4ad1-ab65-e7fe4349a786/chat'
const PROVIDER_CHAT_URL =
  'https://webhookff.fairfashion.io/webhook/5e8350f2-7c95-44a6-8da9-400b6a0f63c3/chat'

import { env } from '../../configs/env.config'
import { AuthContext } from '../../contexts/auth'

export const ChatAI = () => {
  const token = localStorage.getItem(env.LOCAL_STORAGE_LOGIN_TOKEN)
  const { user } = useContext(AuthContext)

  const url =
    user?.company?.segment === 'fashion_company' ||
    user?.company?.segment === 'blockforce'
      ? FASHION_COMPANY_CHAT_URL
      : PROVIDER_CHAT_URL

  useEffect(() => {
    createChat({
      webhookUrl: url,
      initialMessages: [
        'Olá 👋, eu sou o assistente do FairFashion.',
        'Fique à vontade para tirar dúvidas e perguntar qualquer informação que deseja.',
      ],
      metadata: {
        token,
      },
      defaultLanguage: 'en',
      i18n: {
        en: {
          title: 'FairFashion',
          subtitle: '',
          inputPlaceholder: 'Digite sua pergunta',
          closeButtonTooltip: 'Fechar',
          getStarted: 'Iniciar',
          footer: '',
        },
      },
    })
  }, [])

  return <div></div>
}
